import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    company_name:"",
    company_address:"",
    phone:"",
    fax:"",
    setting_grade:"",
    setting_location:"",
    setting_price:"",
    stocked_day_limit:""
  },
  mutations: {

  },
  actions: {}
});
